import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import PropTypes from 'prop-types';
import BoxContainer from '~src/components/BoxContainer';
import { Button } from 'react-bootstrap';
import lastDayOfMonth from 'date-fns/lastDayOfMonth';
import format from 'date-fns/format';
import { initAiCreditPackagesModal } from '~src/sidebar/initAiCreditPackagesModal';
import { getUser } from '~src/user';
import { onErrorShowMessage } from '~src/errors';

const Resoconto = (props) => {
  const [user, setUser] = useState({});

  useEffect(() => {
    // Initialize modal bindings when this component mounts (safe to call repeatedly)
    try {
      initAiCreditPackagesModal();
    } catch (e) {
      // non-blocking
    }

    getUser()
      .then((startup) => {
        setUser(startup.user);
      })
      .catch((err) => {
        console.error(err);
        onErrorShowMessage();
      });
  }, []);

  const {
    credits = {
      freeCreditsAmount: 0,
      paidCreditsAmount: 0,
    },
  } = props;
  const totalCredits = credits.freeCreditsAmount + credits.paidCreditsAmount;

  const Content = () => (
    <>
      <p className="lead text-dark credits-summary__title">
        I tuoi crediti rimanenti
      </p>

      {totalCredits === 0 ? (
        <p className="text-dark credits-summary__empty">
          Non hai crediti a disposizione.
        </p>
      ) : (
        <div className="credits-metrics">
          <div className="credits-metric credits-metric--total">
            <span className="credits-metric__value">{totalCredits}</span>
            <span className="credits-metric__label">crediti</span>
          </div>
        </div>
      )}

      <div className="credits-summary__notes">
        {credits.freeCreditsAmount > 0 && (
          <p className="text-dark">
            I crediti gratuiti scadranno il{' '}
            {format(lastDayOfMonth(new Date()), 'dd/MM/yyyy')}.
          </p>
        )}
        <p className="text-dark">
          Nuovi crediti ti verranno accreditati mensilmente o annualmente in
          base al piano di abbonamento scelto.
        </p>
        <p className="text-dark">I crediti acquistati non hanno scadenza.</p>
      </div>

      {user.org_pointer?.stripe_customer_id && (
        <div className="credits-summary__actions">
          <Button
            variant="primary"
            type="button"
            className="requestBgCredits"
            onClick={() => {
              try {
                $('#aiCreditPackagesModal').modal('show');
              } catch (e) {
                // non-blocking
              }
            }}
          >
            Ricarica Saldo Crediti
          </Button>
        </div>
      )}

      {/* Guide link removed */}
    </>
  );

  if (props.flat) {
    return (
      <div className="credits-summary">
        <Content />
      </div>
    );
  }

  return (
    <BoxContainer
      xsColSize={12}
      xsColOffset={0}
      smColSize={10}
      smColOffset={1}
      lgColSize={6}
      lgColOffset={3}
      theme="light"
    >
      <Content />
    </BoxContainer>
  );
};

Resoconto.propTypes = {
  credits: PropTypes.object,
  flat: PropTypes.bool,
};

export default Resoconto;
